import {Spin, Typography} from "antd";
//import {clearBodyLocks} from "tua-body-scroll-lock";

const { Title} = Typography;

const CentralLoading = () => {

    // Goes along with IOS fix in PortalModal (this resets in case of crash with modal open)
    // DP 2/3/26 - goes with code in PortalModal (not in use)
    //clearBodyLocks();

    // Background loading (cant use translation a this level)
    return (
        <div className="dp-centre-screen">
            <Spin size="large" className="dp-spin"/>
            <Title level={2}>loading<span className=" dp-flashing-dots">...</span></Title>
        </div>
    );
}

export default CentralLoading;